import React, { useContext } from 'react';
import styled from 'styled-components';
import { FdrMapProvider } from '@hotelplan/fdr.regular.fusion.fdr-map';
import { sx2CssThemeFn } from '@hotelplan/util.theme.sxc';
import { productFdrMapOptions } from 'components/domain/fdr-map';
import { FdrGeoTripsContext } from './fdr-geo-trips.context';

const PRODUCT_ROUTES_MAP_ZOOM = 12;

const Container = styled.div<{ height: number }>(({ theme }) =>
  sx2CssThemeFn(({ height }) => ({
    position: 'relative',
    width: `100%`,
    height: `${height}px`,
    ...theme.map.controls,
    '.gm-style-iw-c.nearby': {
      marginLeft: '-300px',
      marginTop: '-195px',
    },
    '.gm-style-iw-c.related': {
      marginLeft: '30px',
      marginTop: '-180px',
      minWidth: '300px !important',
    },
  }))
);

type TProps = React.PropsWithChildren<{
  height?: number;
}>;

const FdrGeoTripsMap = React.forwardRef<HTMLDivElement, TProps>(
  ({ children, height = 768 }, ref) => {
    const { isFullScreen } = useContext(FdrGeoTripsContext);

    const mapHeight = isFullScreen ? '100vh' : `${height}px`;

    return (
      <Container ref={ref} height={height}>
        <FdrMapProvider
          styles={{ width: `100%`, height: mapHeight }}
          zoom={PRODUCT_ROUTES_MAP_ZOOM}
          options={productFdrMapOptions}
        >
          {children}
        </FdrMapProvider>
      </Container>
    );
  }
);

FdrGeoTripsMap.displayName = 'TripMap';

export default FdrGeoTripsMap;
